/* Reasons Why template, the only JavaScript in the template.
   One job: show the sticky CTA bar once the hero has scrolled away, and hide it
   again while the buy box is on screen. IntersectionObserver only, no scroll
   listener, no layout reads on the main thread. */
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.lpRwReady === '1') return;
    bar.dataset.lpRwReady = '1';

    var hero = document.querySelector('[data-lp-rw-hero]');
    var buyBox = document.getElementById('lp-buy-box');
    var pastHero = !hero;      // no hero on the page means "already past it"
    var atBuyBox = false;

    function sync() {
      bar.classList.toggle('is-visible', pastHero && !atBuyBox);
    }

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(hero);
    }

    if (buyBox) {
      new IntersectionObserver(function (entries) {
        atBuyBox = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(buyBox);
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-lp-rw-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', boot);
})();